var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-error-box"},[_c('div',[_c('div',{staticClass:"el-icon-coffee-cup"}),_c('div',{staticClass:"message"},[_vm._v("404")])])])}]

export { render, staticRenderFns }